/**
 * Social - Print - Share
 */

import React from 'react'

export type PrintProps = {
  url?: string
}

function handlePrint() {
  setTimeout(() => {
    if (window) {
      window.print()
    }
  }, 100)
}

// eslint-disable-next-line import/prefer-default-export
export const PrintShare = ({ url }: PrintProps) => (
  <a href={url} onClick={handlePrint}>
    <i className="fas fa-print" />
  </a>
)
